import "./CardGrid.scss";

import clsx from "clsx";

import { FCCC } from "@/types";

/**
 * Grid for `ProductCard`s, sized like `TilesGrid`: as many 300px-min columns
 * as the content zone fits, stretched evenly to fill the row, 24px gap.
 * Unlike `TilesGrid` it carries no minimum height, so a short row of cards
 * does not reserve empty space below itself.
 */
export const CardGrid: FCCC = ({ className, children }) => (
  <div className={clsx("card-grid", className)}>{children}</div>
);
